/**
 * Define your redux middleware here and
 * export them to your redux store
 */
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

export default middleware;
